import { useState } from "react";

const useToken = () => {
  const getToken = () => localStorage.getItem("access_token");
  const getRefreshToken = () => localStorage.getItem("refresh_token");

  const [token, setToken] = useState(getToken());

  const saveToken = (accessToken, refreshToken) => {
    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("refresh_token", refreshToken);
    setToken(accessToken);
  };

  const removeToken = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setToken(null);
  };

  const isTokenExpired = (t) => {
    if (!t) return true;
    try {
      const { exp } = JSON.parse(atob(t.split(".")[1]));
      // Treat as expired 30s early to avoid clock-skew races
      return Date.now() >= exp * 1000 - 30000;
    } catch {
      return true;
    }
  };

  const refreshAccessToken = async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
      removeToken();
      window.location.href = "/";
      return null;
    }

    try {
      const response = await fetch("/api/refresh", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refresh_token: refreshToken }),
        credentials: "include",
      });

      if (response.ok) {
        const data = await response.json();
        saveToken(data.access_token, data.refresh_token);
        return data.access_token;
      } else {
        removeToken();
        window.location.href = "/";
        return null;
      }
    } catch (error) {
      console.error("Failed to refresh token:", error);
      removeToken();
      window.location.href = "/";
      return null;
    }
  };

  // Use this instead of `await getValidToken()`.
  // Checks real expiry so a stale-but-truthy token triggers a refresh.
  const getValidToken = async () => {
    const stored = getToken();
    if (!stored || isTokenExpired(stored)) {
      return await refreshAccessToken();
    }
    return stored;
  };

  return { token, saveToken, removeToken, refreshAccessToken, getToken, getValidToken };
};

export default useToken;
